/* eslint-disable no-shadow,prefer-const */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import withWidth, { LARGE, SMALL } from '@material-ui/core/withWidth';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { getFilteredMenu } from '../redux/actions/moduleActions';

import Header from '../app/header/Header';
import LeftDrawer from '../app/drawer/Drawer';
import { loadingTheme, changeTheme } from '../redux/actions/appActions';
import { setProgramContext, setProgramsList } from '../redux/actions/financial/programContextActions';
import Dashboard from '../components/dashboard/Dashboard';

import Loading from '../components/util/Loading';


const mapStateToProps = state => ({
  menu: state.moduleReducer.modulesFiltered,
  auth: state.auth,
  themeConfig: state.appReducer.themeConfig,
  themeLoading: state.appReducer.loadingTheme,
  loading: state.appReducer.loading,
});

const mapDispatchToProps = {
  getFilteredMenu,
  loadingTheme,
  changeTheme,
  setProgramContext,
  setProgramsList,
};

class App extends Component {

  static propTypes = {
    width: PropTypes.string,
  };

  constructor(props) {

    super(props);
    this.state = {
      navDrawerOpen: true,
    };

    this.handleChangeRequestNavDrawer = this.handleChangeRequestNavDrawer.bind(this);

  }

  componentDidMount() {

    const { auth, getFilteredMenu } = this.props;
    const theme = localStorage.getItem('theme');

    if (auth.user) getFilteredMenu();


    if (!theme) this.loadTheme();

    const body = document.querySelector('body');


  }

  componentWillReceiveProps(nextProps) {

    if (this.props.width !== nextProps.width) this.setState({ navDrawerOpen: nextProps.width === LARGE });


    if (nextProps.auth.user && !this.props.auth.user) this.props.getFilteredMenu();


  }

  handleChangeRequestNavDrawer() {

    this.setState({
      navDrawerOpen: !this.state.navDrawerOpen,
    });

  }

  loadTheme() {

    const { loadingTheme } = this.props;

    setTimeout(() => loadingTheme(false), 500);

  }

  render() {

    const {
      menu, auth, themeConfig, themeLoading, loading, children,
    } = this.props;
    const { navDrawerOpen } = this.state;
    const paddingLeftDrawerOpen = 220;

    const styles = {
      header: {
        paddingLeft: navDrawerOpen ? paddingLeftDrawerOpen : 0,
      },
      container: {
        margin: '80px 20px 20px 15px',
        paddingLeft: navDrawerOpen && this.props.width !== SMALL ? paddingLeftDrawerOpen : 0,
      },
    };

    return (

      <div>
        {themeLoading && <h2>{I18n.t('application.loading_theme')}</h2>}
        {!themeLoading && (
        <MuiThemeProvider theme={themeConfig}>
          <div>
            { loading
            && <Loading />
            }
            <Dashboard openRoute={children} />
            {/* <Header
              styles={styles.header}
              handleChangeRequestNavDrawer={this.handleChangeRequestNavDrawer}
            />

            <LeftDrawer
              navDrawerOpen={Boolean(navDrawerOpen)}
              menus={menu}
              user={auth.user}
              width={paddingLeftDrawerOpen}
              themeConfig={themeConfig}
            />

            <div style={styles.container}>
              {this.props.children}
            </div> */}
          </div>
        </MuiThemeProvider>
        )}
      </div>
    );

  }
}

export default withWidth()(
  connect(mapStateToProps, mapDispatchToProps)(App),
);



// WEBPACK FOOTER //
// ./src/containers/App.js